/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {transformJsonObjectProperty} from '../util/adn-http-resource-transforms';
import {AdnApiClientService} from '../../app/common/controller/adn-api-client.service';
import {SignalAdminResourceApiBase, SignalAdminResourceModel} from '../../app/common/controller/signal-admin-resource-api';

export interface NetworkProfileModel extends SignalAdminResourceModel {
  profile?: Record<string, any>;
}

const transforms = transformJsonObjectProperty('profile');

@Injectable({providedIn: 'root'})
export class NetworkProfileApiService extends SignalAdminResourceApiBase<NetworkProfileModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'networkprofiles');
  }

  override get(id: string): Observable<NetworkProfileModel> {
    return super.get(id).pipe(map(transforms.transformResponse));
  }

  override save(model: NetworkProfileModel): Observable<NetworkProfileModel> {
    return super.save(transforms.transformRequest(model)).pipe(map(transforms.transformResponse));
  }
}
